import React from 'react';
import { Target, MapPin, BookOpen } from 'lucide-react';
import { motion } from 'framer-motion';
const audiences = [{
  icon: <Target className="text-gold" size={20} data-id="element-28" />,
  title: 'Entrenadores sin título formal',
  desc: 'Barriales y de liga zonal que saben de futsal pero no tienen metodología.'
}, {
  icon: <MapPin className="text-gold" size={20} data-id="element-29" />,
  title: 'Entrenás con lo que hay',
  desc: 'Con una cancha alquilada, conos y pelota te alcanza. Sin instalaciones caras.'
}, {
  icon: <div className="text-gold" size={20} data-id="element-30" />,
  title: 'Ex jugadores que ahora dirigen',
  desc: 'Conocés el juego desde adentro pero no sabés cómo transmitirlo como DT.',
  badge: 'NUEVO'
}, {
  icon: <BookOpen className="text-gold" size={20} data-id="element-31" />,
  title: 'Profes de Ed. Física con equipo',
  desc: 'Tenés la base teórica pero te falta lo específico del futsal amateur argentino.'
}];
export function Audience() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-10 md:py-20 bg-[#0F172A] px-4 border-y border-gray-800" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        <div className="text-center mb-6 md:mb-12" data-id="element-34">
          <h2 className="font-display text-3xl md:text-5xl text-white mb-2 md:mb-4 uppercase" data-id="element-35">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-base md:text-lg text-gray-300 font-medium" data-id="element-36">
            Diseñado para vos si querés llevar tu equipo al próximo nivel
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-12" data-id="element-37">
          {audiences.map((aud, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gray-800 p-4 md:p-6 rounded-2xl shadow-sm border border-gray-700 flex gap-3 md:gap-4 relative overflow-hidden group hover:border-gold/40 transition-colors" data-id="element-38">
              <div className="bg-gold/10 border border-gold/20 w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-39">
                {aud.icon}
              </div>
              <div data-id="element-40">
                <div className="flex items-center gap-2 mb-1 md:mb-2" data-id="element-41">
                  <h3 className="font-bold text-base md:text-lg text-white leading-tight" data-id="element-42">
                    {aud.title}
                  </h3>
                  {aud.badge && <span className="bg-gold text-dark text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider shrink-0" data-id="element-43">
                      {aud.badge}
                    </span>}
                </div>
                <p className="text-gray-400 text-xs md:text-sm leading-relaxed" data-id="element-44">
                  {aud.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-45">
          <button onClick={scrollToPricing} className="inline-flex items-center gap-2 text-gold font-bold hover:text-gold-dark transition-colors text-sm md:text-base" data-id="element-46">
            ¿No estás seguro si es para vos? Tenés 7 días de garantía →
          </button>
        </div>
      </div>
    </section>;
}